import type { RouteLocationRaw } from '#vue-router'

export function correctAssetRoutes(x) {
  return replaceAll(x, 'public/', '')
}

export function replaceAll(object, original, replacement) {
  const regExp = new RegExp(original, 'g')
  return JSON.parse(JSON.stringify(object).replace(regExp, replacement))
}

export function getSlug(path: string) {
  const pathParts = path.split('/')
  if (pathParts.length > 1 && ['articles'].includes(pathParts[1])) {
    return `${path}`
  }
  return `/${pathParts[pathParts.length - 1]}`
}

export function getPage({ url, to, uid }: { url?: string, to?: string, uid?: string }): RouteLocationRaw | string {
  if (url) {
    return url
  }
  if (!to && !uid && !url) {
    return '/'
  }
  const path = to === 'homepage' ? '/' : (to?.startsWith('/') ? '' : '/') + to
  const route: RouteLocationRaw = { path }
  if (uid) {
    const hash = uid.replace(/ /g, '%20')
    return { hash: hash }
  }
  else {
    return route
  }
}

export function parseDate(dateString: string) {
  const datePart = dateString.slice(0, 8)
  const timePart = dateString.slice(9)

  const year = parseInt(datePart.slice(0, 4), 10)
  const month = parseInt(datePart.slice(4, 6), 10) - 1 // Months are zero-based in JavaScript
  const day = parseInt(datePart.slice(6, 8), 10)

  const [hours, minutes] = timePart.split(':').map(part => parseInt(part, 10))

  return new Date(year, month, day, hours, minutes)
}

export function getLowercaseLetter(index: number): string {
  return String.fromCharCode(97 + index)
}

export function minutesToHoursAndMinutes(totalMinutes: number = 0): string {
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  const minuteText = minutes === 1 ? 'minute' : 'minutes'
  if (hours === 0) {
    return `${minutes} ${minuteText}`
  }

  const hourText = hours === 1 ? 'Hour' : 'Hours'

  if (minutes === 0) {
    return `${hours} ${hourText}`
  }

  return `${hours} ${hourText} ${minutes} ${minuteText}`
}
